import type { ZudokuConfig } from "zudoku";
import { portalSupabaseConfig } from "./portalSupabaseConfig";
import requestIdleCallbackPolyfill from "./plugins/requestIdleCallbackPolyfill";

const config: ZudokuConfig = {
  site: {
    title: "Vocal Journaling API",
  },
  metadata: {
    title: "Vocal Journaling API",
    description: "Developer portal for the vocal journaling API gateway.",
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "doc",
          file: "introduction",
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/api" }],
  authentication: {
    type: "supabase",
    supabaseUrl: portalSupabaseConfig.url,
    supabaseKey: portalSupabaseConfig.anonKey,
    onlyThirdPartyProviders: false,
    redirectToAfterSignIn: "/api",
    redirectToAfterSignUp: "/api",
    redirectToAfterSignOut: "/api",
  },
  apiKeys: {
    enabled: true,
  },
  apis: [
    {
      type: "file",
      input: "../config/routes.oas.json",
      path: "api",
    },
  ],
  plugins: [requestIdleCallbackPolyfill()],
};

export default config;
